<div
	class="pagination"
	[class.disabled]="isLoading()"
>
	@if (total() > pageSize()) {
		<tui-pagination
			class="tui-pagination"
			[length]="pageCount"
			[(index)]="paginationIndex"
		/>
	}
</div>
